import { createStructuredSelector } from 'reselect';

export const userCategoriesSelector = (state: RootState) => state.categories.userCategories.categories;
export const userCategoriesStatusSelector = (state: RootState) => state.categories.userCategories.status;

export const categoriesSelector = createStructuredSelector({
  categories: userCategoriesSelector,
  status: userCategoriesStatusSelector,
});
